import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Paper } from '@material-ui/core';

import { Typography } from '../../../../components/Wrappers/Wrappers.jsx';
import { useStyles } from './styles.js';
import VerificationCard from './verificationCard/index.jsx';
import useTwoStepVerification from './useTwoStepVerification.jsx';
import VerifyOTP from '../../../../components/VerifyOTP';
import EnterPhoneNumber from '../../../../components/EnterPhoneNumber';

function TwoStepVerification () {
  const classes = useStyles();
  const [phoneNumberEdit, setPhoneNumberEdit] = useState(false);
  const [isLoadingVerify, setIsLoadingVerify] = useState(false);

  const {
    userAttributes,
    showOtp,
    setShowOtp,
    renderOtpSuccessDialog,
    renderErrorDialog,
    sendPhoneNumberVerificationCode,
    confirmPhoneNumberVerificationCode,
    updatePhoneNumber,
    cancelPhoneVerification,
    cancelEnterPhoneNumber,
  } = useTwoStepVerification();

  const handleVerifyButtonClick = async () => {
    setIsLoadingVerify(true);
    try {
      const result = await sendPhoneNumberVerificationCode();
      if (!result.hasError) {
        setShowOtp(true);
      }
    } finally {
      setIsLoadingVerify(false);
    }
  };

  return (
    <React.Fragment>
      <Paper className={classes.root} elevation={0}>
        <Typography variant={'h5'} weight={'medium'} className={classes.header}>
          2-step verification
        </Typography>

        <VerificationCard
          cardId={'phone'}
          cardLabel={'Phone Number'}
          cardValue={userAttributes?.phone_number || 'Add phone'}
          isEditable={'true'}
          isVerified={userAttributes?.phone_number_verified}
          isLoading={isLoadingVerify}
          onChangeButtonClick={() => {
            setPhoneNumberEdit(true);
          }}
          onVerifyButtonClick={handleVerifyButtonClick}
        />

        <VerificationCard
          cardId={'email'}
          cardLabel={'Signing OTP email'}
          cardValue={userAttributes?.email || 'Add email'}
          isEditable={'false'}
          isVerified={userAttributes?.email_verified}
        />
      </Paper>

      <VerifyOTP
        open={showOtp}
        onVerify={async (otp) => {
          await confirmPhoneNumberVerificationCode({ code: otp });
        }}
        onResendOTP={async () => await sendPhoneNumberVerificationCode({ isResend: true })}
        onClose={() => cancelPhoneVerification()}
      />

      <EnterPhoneNumber
        open={phoneNumberEdit}
        onCancel={() => {
          setPhoneNumberEdit(false);
          cancelEnterPhoneNumber();
        }}
        onVerify={async (phone) => {
          const updateResult = await updatePhoneNumber({ phoneNumber: phone });
          if (updateResult.hasError) return;
          const sendResult = await sendPhoneNumberVerificationCode();
          if (sendResult.hasError) return;
          setPhoneNumberEdit(false);
          setShowOtp(true);
        }}
      />

      {renderOtpSuccessDialog()}

      {renderErrorDialog()}
    </React.Fragment>
  );
}

export default observer(TwoStepVerification);
